
<style scoped>
    .Steps {
        margin-bottom: 1rem;
        width: 200px;
    }

    .progress-bar-label {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .progress-bar-label span.title {
        /* font-size: 1rem; */
        font-weight: bold;
        padding-left: 2px;
    }

    .progress-bar-label span.page {
        /* font-size: 0.8rem; */
        font-weight: 600;
        font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New",
            monospace;
    }

    .progress-bar-wrapper {
        width: 100%;
        /* margin-top: 0.2rem; */
    }

    .progress-bar {
        width: 100%;
        /* background-color: #e0e0e0; */
        /* background-color: rgb(106, 112, 117); */
        background-color: rgb(237, 237, 237);

        /* padding: 3px; */
        /* border-radius: 3px; */
        /* box-shadow: inset 0 1px 3px rgba(182, 137, 137, 0.2); */
        /* /* border: 1px groove rgb(192, 192, 192); */
        /* border: 1px solid rgba(164, 164, 164, 1); */
        border: 2px solid rgb(37, 42, 43);
    }

    .progress-bar-fill {
        /* display: block; */
        display: flex;
        justify-content: flex-end;
        height: 14px;
        /* background-color: #659cef; */
        background-color: hsl(0, 100%, 71%);

        /* border-radius: 3px; */

        transition: width 200ms ease-in-out;
        /* transition: width 250ms ease; */
    }

    .progress-bar-step {
        display: block;
        height: 14px;
        /* background-color: #8ab4f8; */
        background-color: hsl(0, 100%, 76%);
        /* transition: width 250ms ease-in-out; */
    }
</style>


<template lang="pug">

.Steps.flex.col

    .progress-bar-label
        span.title {{ title }}
        //- span.page Page {{ Math.min( step, steps ) }} of {{ steps }}
        span.page {{ Math.min( step, steps ) }}/{{ steps }}

    .progress-bar-wrapper
        .progress-bar
            span.progress-bar-fill( :style="{ width: perc }" )
                span.progress-bar-step( :style="{ width: step_width }" )



</template>


<script>

import { defineComponent, ref, reactive, computed } from 'vue'

// import useState from '../state'

export default defineComponent( {

    name: 'Steps',

    props: ['step', 'steps', 'title'],

    setup( props ) {

        // const { form } = useState()

        const perc = computed( () => `${ props.step === props.steps ? 100 : Math.round( props.step / props.steps * 100 ) }%` )

        // const step_width = computed( () => `${ Math.round( ( props.step / props.steps * 100 ) / props.steps ) }%` )

        const step_width = computed( () => `${ props.step === props.steps ? 100 : Math.round( 100 / props.step ) }%` )


        return {
            perc, step_width,
        }

    },

} )
</script>